export enum CodeLanguage {
  cpp = 'cpp',
  java = 'java',
  js = 'js',
}
